import { PermissionEnum } from '../../../../enums/PermissionEnum'
import { AuthModel } from './AuthModel'
import { UserAddressModel } from './UserAddressModel'
import { UserCommunicationModel } from './UserCommunicationModel'
import { UserEmailSettingsModel } from './UserEmailSettingsModel'
import { UserSocialNetworksModel } from './UserSocialNetworksModel'

export interface UserModel {
  id: string
  username: string
  password: string | undefined
  email: string
  firstname: string
  lastname: string
  fullname?: string
  occupation?: string
  companyName?: string
  phone?: string
  roles?: Array<string>
  permissions?: Array<string>
  rolesString?: Array<string>
  pic?: string
  language?: 'en' | 'de' | 'es' | 'fr' | 'ja' | 'zh' | 'ru'
  timeZone?: string
  website?: 'https://keenthemes.com'
  emailSettings?: UserEmailSettingsModel
  auth?: AuthModel
  communication?: UserCommunicationModel
  address?: UserAddressModel
  socialNetworks?: UserSocialNetworksModel
}

export function checkPermission(user: UserModel, permission: PermissionEnum) {
  return user.permissions?.find(i => i == PermissionEnum[permission]);
}
